module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_title_1-74f266c9a746917f0a5e212d5cf1229e.webp";